export default __webpack_public_path__ + "images/B4.32c658a.png";